<template>
  <div>
    <right-panel class="float-right" id="sidebar-edit-account" width="1000px" :icon="'mdi mdi-plus'" :text="$t('account.new-user')" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Edit :hide-library="true" />
      </div>
    </right-panel>

    <div>
      <h2>{{ $t("account.user-list") }}</h2>
    </div>

    <div class="bg-white">
      <table class="table table-bordered table-striped">
        <thead class="bg-secondary text-white">
          <tr>
            <th>{{ $t("common.type") }}</th>
            <sortable-table-head field="name" :text="$t('common.name')" :request="request" />
            <th>{{ $t("common.email") }}</th>
            <th>{{ $t("common.phone-number") }}</th>
            <th>{{ $t("common.description") }}</th>
            <th>{{ $t("common.created-at") }}</th>
            <th>{{ $t("common.activated-at") }}</th>
            <th>{{ $t("common.deactivated-at") }}</th>
            <th scope="col" style="width: 15%">
              <a href="javascript:;" @click="toggleFilter">
                <span v-if="filterEnabled" class="text-warning">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-hide") }}
                </span>
                <span v-else class="text-white">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-show") }}
                </span>
              </a>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-if="filterEnabled">
            <th>
              <select class="form-control " v-model="type">
                <option :value="undefined">{{ $t("common.all") }}</option>
                <option value="system">{{ $t("common.system") }}</option>
                <option value="account">{{ $t("common.account") }}</option>
              </select>
            </th>
            <th><input class="form-control " v-model="nameFilter" :placeholder="$t('common.search')" /></th>
            <th></th>
            <th><input class="form-control " v-model="phoneFilter" :placeholder="$t('common.phone-number')" /></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>

          <template v-if="pagination">
            <tr v-for="item in pagination.docs" :key="item._id" :class="!item.credential.active ? 'bg-soft-danger' : ''">
              <td>{{ item.type }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.credential.email }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.credential.createdDate | date(true) }}</td>
              <td>{{ item.credential.activatedDate | date(true) }}</td>
              <td>{{ item.credential.deactivatedDate | date(true) }}</td>
              <td>
                <div class="font-size-16 text-center">
                  <i class="bx bx-trash-alt text-danger hand mr-3" v-b-tooltip.hover :title="$t('common.delete')" v-b-modal="'account-delete-option-modal' + item._id"></i>
                  <i class="bx bx-pencil text-primary hand" v-b-tooltip.hover :title="$t('common.edit')" @click="edit(item)"></i>
                  <AccountDeleteOptionModal :id="'account-delete-option-modal' + item._id" :account="item" :strict="false" @remove="remove" />
                </div>
              </td></tr
          ></template>
        </tbody>
      </table>
    </div>

    <content-loading v-if="loading" />

    <empty v-if="!loading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center" id="myText">
        {{ $t("account.system.no-users") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->
    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import AccountDeleteOptionModal from "@cc/account-delete-option-modal";
import Edit from "./management-account-edit-form";

const state = "managementAccount";
export default {
  components: {
    Edit,
    AccountDeleteOptionModal,
  },
  data() {
    return {
      request: {
        options: { page: 1, limit: 10, sort: { "scope.management": "asc" } },
        query: {},
      },
      nameFilter: undefined,
      phoneFilter: undefined,
      type: undefined,
      filterEnabled: false,
    };
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounceMixin(() => this.init());
      },
    },

    nameFilter(n, o) {
      this.request.query = {
        ...this.request.query,
        name: { value: n },
      };
    },

    phoneFilter(n, o) {
      this.request.query = {
        ...this.request.query,
        phone: { value: n },
      };
    },
    type(n, o) {
      if (n) {
        this.request.query = {
          ...this.request.query,
          type: { value: n },
        };
      } else {
        this.request.query = {};
      }
    },
  },
  computed: {
    pagination() {
      return this.$store.getters[`${state}/pagination`];
    },
    loading() {
      return this.$store.getters[`${state}/isLoading`];
    },
  },
  methods: {
    init() {
      this.$store.dispatch(`${state}/paginate`, this.request);
    },
    rightPanelClosed() {
      this.$store.commit(`${state}/editedEntity`, null);
      this.init();
    },

    edit(item) {
      this.$store.commit(`${state}/editedEntity`, item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-edit-account");
    },

    async remove(payload) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch(`${state}/delete`, payload);
        this.$toast.success(this.$t("common.delete-successful"));
        this.init();
        this.$emit("accountDeleted");

        this.$bvModal.hide(`account-delete-option-modal${payload.id}`);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
  },
};
</script>
